import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Immutable } from 'nuclear-js';
import moment from 'moment';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import GrowthGoalsUtils from '../utils';
import TermUtils from 'utils/terms';

export default CreateReactClass({
    displayName: 'delete-goal-modal',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            show: false,
        };
    },

    promise: null,
    resolve: null,
    reject: null,
    goal: null,

    show(goal) {
        this.setState({
            show: true,
        });
        this.goal = goal;

        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        return this.promise;
    },

    onCancel() {
        this.reject();
        this.setState({ show: false });
        this.goal = null;
    },

    onDelete() {
        this.resolve();
        this.setState({ show: false });
        this.goal = null;
    },

    renderTable(goal) {
        if (!goal) {
            return null;
        }

        const typicalGrowth = GrowthGoalsUtils.typicalGrowth(goal);
        const startingScore = GrowthGoalsUtils.startingScore(goal, true);
        const header = (
            <div key="header-upcoming-growth-goal" className="row-goal-grid-header delete-goals-modal">
                <span key="term">Term</span>
                <span key="set-goal">Set Goal</span>
                <span key="typical-growth">Projected Growth</span>
                <span key="starting-score">Starting Score</span>
                <span key="edit-info">Set On/by</span>
            </div>
        );
        const row = (
            <div key={goal.get('growthGoalBid')} className="row-goal-grid-content delete-goals-modal">
                <span className="goal-termDate">{TermUtils.textFromTermNumber(goal.get('endTermNumber'), true)}</span>
                <span>{goal.get('targetScore')}</span>
                <span className={typicalGrowth.className}>{typicalGrowth.description}</span>
                <span className={startingScore.className}>{startingScore.description}</span>
                <span>
                    {moment.utc(goal.get('dateEdited')).format('MM/DD/YYYY')}
                    <br />
                    {goal.get('educatorName')}
                    <br />
                    {goal.get('actionPlan') ? 'Action Plan' : ''}
                </span>
            </div>
        );
        return [header, row];
    },

    renderButtons(idSuffix) {
        return [
            <Button
                key="cancel-button"
                id={`delete-goal-modal-cancel-button-${idSuffix}`}
                bsClass="cancel-button btn"
                onClick={this.onCancel}
            >
                cancel
            </Button>,
            <Button
                key="delete-button"
                id={`delete-goal-modal-delete-button-${idSuffix}`}
                bsClass="ok-button btn"
                onClick={this.onDelete}
            >
                delete
            </Button>,
        ];
    },

    render() {
        const subjectBid = this.props.subject.get('bid');
        const content = [<p key="delete-text">Delete this student goal?</p>].concat(this.renderTable(this.goal));
        const buttons = this.renderButtons(subjectBid);

        return (
            <Modal
                id={`delete-goal-modal-for-subject-${subjectBid}`}
                bsSize="lg"
                aria-labelledby="delete-goal-modal"
                onHide={this.onCancel}
                bsClass="growth-goal-modal modal"
                show={this.state.show}
            >
                <Modal.Header key="header" closeButton={true}>
                    <Modal.Title>DELETE GOAL</Modal.Title>
                </Modal.Header>
                <Modal.Body key="body" bsClass="modal-body growth-goal">
                    {content}
                </Modal.Body>
                <Modal.Footer>{buttons}</Modal.Footer>
            </Modal>
        );
    },
});
